import React from 'react';
import Icon from './Icon';

export default function Caret(props) {
    return (
        <Icon {...props}>
            <path d="M16.2,24l-8.1-8L0,8h32l-7.8,8L16.2,24z" />
        </Icon>
    );
}
